/**
 * @generated SignedSource<<71adb8bb5f21384df22498dd31c75e0d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileBlockButton_profile$data = {
  readonly name: string;
  readonly userId: any;
  readonly " $fragmentType": "ProfileBlockButton_profile";
};
export type ProfileBlockButton_profile$key = {
  readonly " $data"?: ProfileBlockButton_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileBlockButton_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileBlockButton_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "9faa816c2da0c244dddf885063cf3000";

export default node;
